import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class DistrictesService {
  private apiUrl = `${this.SharedProperties.baseUrlService()}/MOE/services/districtes/`;
  private districtes: any[] = [];

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $http: angular.IHttpService
  ) { }

  init(): angular.IPromise<any[]> {
    return this.$http
      .get(`${this.apiUrl}findAll?`)
      .then((response: any) => {
        this.districtes = response.data.districtes;
        return this.districtes;
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.districtes;
      });
  }

  getDistrictes(paramsDist: any): angular.IPromise<any[]> {
    const _params = { ...paramsDist };

    return this.$http
      .get(`${this.apiUrl}find?`, { params: _params })
      .then((response: any) => {
        this.districtes = response.data.districtes;
        return this.districtes;
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.districtes;
      });
  }

  setDistrictesParams(paramsArray: any[], paramsDistricte: any): any {
    paramsArray.forEach((param) => {
      paramsDistricte = { ...paramsDistricte, ...param };
    });
    return paramsDistricte;
  }
}

angularJsApp.service(AppServicesEnum.DISTRICTES_SERVICE, DistrictesService);